import React from 'react';
import { any, bool, func, number, string } from 'prop-types';
import animate from './animation';


/**
 * For icons or logos from the API
 * Also for static icons which need to rotate dynamically
 */

DynamicIcon.propTypes = {
  logoRectSize: number,
  animation: bool,
  rotate: number,
  onClick: func,
  x: number,
  y: number,
  href: any,
  id: string,
  floorLevel: number
};

function DynamicIcon(props) {
  const {
    x: initialX,
    y: initialY,
    href,
    rotate,
    onClick,
    animation,
    logoRectSize,
    id,
    floorLevel
  } = props;
  const thisRef = React.useRef();


  React.useEffect(() => {
    if (animation && thisRef.current) {
      const iconContainer = thisRef.current;
      const img = iconContainer.querySelector('image');
      animate(iconContainer, img);
    }
  }, ['didMount']);
  return (
    <g 
      transform={`rotate(-${rotate} ${initialX} ${initialY})`} 
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <g transform={`translate(${initialX - logoRectSize / 2} ${initialY - logoRectSize / 2})`}>
        <g className={animation && "container_icon"} ref={thisRef}>
          <rect width={logoRectSize} height={logoRectSize} fill="transparent" />
          <image width={logoRectSize} height={logoRectSize} href={href || undefined} style={{ pointerEvents: 'none' }} />
        </g>
      </g>
    </g>
  );
};

DynamicIcon.defaultProps ={
  logoRectSize: 16,
  rotate: 0
}

export default DynamicIcon;